/* unplugin-vue-components disabled */import script from "./WOItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WOItemCard.vue?vue&type=script&setup=true&lang=js"

import "./WOItemCard.vue?vue&type=style&index=0&id=efeb77c4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efeb77c4"]])

export default __exports__